<template>
  <div class="contact-container light" :class="{active:!loading}">
    <div class="content">
      <div class="content-main">
        <div class="icon-plus"></div>
        <div class="line line-h"></div>
        <div class="line line-v"></div>
        <div class="text-contact">
          <img :src="resources['contactTextContact'].src"/>
        </div>
        <div class="text-us">
          <img :src="resources['contactTextUs'].src"/>
        </div>
        <img :src="resources['contactBuilding'].src" class="building"/>
        <div class="contact-method">
          <div class="mobile">电话：（86）025-68586767 / 68586500</div>
          <div class="fax">传真：（86）025-6859-8439 </div>
          <div class="address">地址：中国江苏省南京市鼓楼区中山北路8号云峰大厦19F　210008 </div>
          <div class="email">邮箱：hr@yinduogilvy.com</div>
          <div class="wechat">
            <span>官方微信：</span>
            <img :src="resources['contactQrcode'].src" class="qrcode"/>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
export default {
  name:'Join',
  data(){
    return {
      loading:true,
      resources:null
    }
  },
  created(){
    this.$store.dispatch('changeTheme',"white");
    this.resources = this.$store.state.resources;
  },
  mounted(){
    this.loading = false;
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('changeTheme','');
    next();
  }
}
</script>
<style lang="scss" scoped>
  @import "../common/common.scss";
  @import "../common/theme.scss";
  .contact-container {
    min-width:1200px;
    background-color: $themeColor;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding:  132px 0 0;

  }
  .content {
    max-width: 1361px;
    width: 1361px;
    width: px2percent(1361,1920);
    max-height: 678px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%,-50%,0);
  }
  .content-main {
    padding-bottom: px2percent(76,1361);
  }
  .contact-method {
    position: absolute;
    left: px2percent(479,1361);
    top: px2percent(327,678);
    font-size: px2rem(24);
    line-height: 1;
    transform: translate3d(20%,0,0);
    opacity: 0;
    white-space: nowrap;
    div + div {
      margin-top: px2percent(20,708);
      vertical-align: text-top;
      display: flex;
    }
    .qrcode {
      opacity: 0;
      width: px2percent(45,442);
    }
  }
  .text-contact {
    margin-left: px2percent(86,1361);
    width: px2percent(1275,1361);
    img {
      transform: translate3d(10%,0,0);
      opacity: 0;
      width: 100%;
    }
  }
  .text-us {
    margin-left: px2percent(86,1361);
    width: px2percent(358,1361);
    margin-top: px2percent(18,1361);
    overflow: hidden;
    img {
      transform: translate3d(-100%,0,0);
      width: 100%;
    }
  }



  .building {
    position: absolute;
    left: px2percent(12,1361);
    bottom: px2percent(12,678);
    opacity: 0;
    // width: px2percent(687,1361);
    height: px2percent(580,678);
  }
  .icon-plus{
    transform: scale(0);
    position: absolute;
    left: 0;
    bottom: 0;
    &:after,
    &:before{
      content: "";
      position: absolute;
      background: #000;
      top:50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
    }
    &:after {
      width: px2rem(8);
      height: px2rem(48);
    }
    &:before {
      width: px2rem(48);
      height: px2rem(8);
    }
  }
  .line {
    position: absolute;
    &.line-v {
      height: 100%;
      width: px2rem(2);
      bottom: px2percent(27,678);
      overflow: hidden;
      &:after {
        content: "";
        position: absolute;
        border-left: px2rem(2) dashed #000;
        left: 0;
        top: 0;
        height: 100%;
        transform: translate3d(0,100%,0);
      }
    }
    &.line-h {
      width: 100%;
      height: px2rem(2);
      left:  px2percent(27,1361);
      bottom: -1px;
      overflow: hidden;
      &:after {
        transform: translate3d(-100%,0,0);
        content: "";
        position: absolute;
        border-top: px2rem(2) dashed #000;
        left: 0;
        top: 0;
        width: 100%;
      }
    }
  }

  .active {
    .building {
      animation: fadeIn .3s linear forwards;
    }
    .icon-plus {
      animation: icon_anim .9s linear forwards;
    }
    .text-contact,
    .text-us  {
      img {
        animation: transform_anim 1s .3s linear forwards;
      }
    }

    .line-v{
      &:after {
        animation: transform_anim 1.4s linear forwards;
      }
      
    }
    .line-h{
      &:after {
        animation: transform_anim 2s linear forwards;
      }
    }
    .contact-method {
      animation: transform_anim .7s .8s linear forwards;
    }
    .qrcode {
      animation: transform_anim .4s 1s linear forwards;
    }
  }
  @keyframes fadeIn {
    100%{
      opacity: 1;
    }
  }
  @keyframes transform_anim {
    100%{
      transform: none;
      opacity: 1;
    }
  }
  @keyframes icon_anim {
    0%{
      transform: rotateZ(0deg) scale(0) ;
    }
    50%{
      transform: rotateZ(360deg + 21.4deg) scale(1) ;
      
    }
    75%{
      transform: rotateZ(360deg -7.7deg) scale(1) ;
    }
    100%{
      transform: rotateZ(360deg) scale(1) ;
    }
  }
</style>
